import { SxProps } from "@mui/material";
import type { ThemeV2 } from "../../../util/types";

export const AutocompleteContent: SxProps = {
  width: "90%",
};

export const AutocompleteSelectedOptions = (primaryColor: string): SxProps => ({
  display: "flex",
  flexDirection: "column",
  gap: 0.5,
  minHeight: "100px",
  maxHeight: { md: "450px", xs: "250px" },
  overflowY: "auto",
  mb: 2,
  p: 1,
  border: `1px solid ${primaryColor}`,
  borderRadius: "12px",
});

export const AutocompleteSelectedOption: SxProps = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 1,
  py: 0.5,
  px: 1,
};

export const AutocompleteSelectedOptionImage: SxProps = {
  width: { xs: "32px", sm: "40px" },
  height: { xs: "32px", sm: "40px" },
  objectFit: "contain",
};

export const TextInput = (theme: ThemeV2, primaryColor: string): SxProps => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: `${theme.tokens.shape.radius.lg}px`,
    color: primaryColor,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: primaryColor,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: primaryColor,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: primaryColor,
    },
  },
  "& .MuiInputBase-input": {
    padding: `${theme.tokens.spacing["3"]}px`,
    color: primaryColor,
  },
});

export const ModalButton = (theme: ThemeV2): SxProps => ({
  color: theme.tokens.color.action.primaryText,
  padding: `${theme.tokens.spacing["1"]}px ${theme.tokens.spacing["6"]}px`,
  fontSize: theme.tokens.typography.size.lg,
  "&.Mui-disabled": {
    color: theme.tokens.color.text.secondary,
  },
});

export const ModalText = (theme: ThemeV2): SxProps => ({
  fontWeight: theme.tokens.typography.weight.medium,
  color: theme.tokens.color.text.primary,
  fontSize: theme.tokens.typography.size.md,
  margin: 0,
});
